import { render, staticRenderFns } from "./GiveawayTable.vue?vue&type=template&id=3b1b4220&scoped=true"
import script from "./GiveawayTable.vue?vue&type=script&lang=ts"
export * from "./GiveawayTable.vue?vue&type=script&lang=ts"
import style0 from "./GiveawayTable.vue?vue&type=style&index=0&id=3b1b4220&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b4220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1b4220')) {
      api.createRecord('3b1b4220', component.options)
    } else {
      api.reload('3b1b4220', component.options)
    }
    module.hot.accept("./GiveawayTable.vue?vue&type=template&id=3b1b4220&scoped=true", function () {
      api.rerender('3b1b4220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/give-away/GiveawayTable.vue"
export default component.exports